import { __assign, __rest } from "tslib";
import React from 'react';
import { twMerge } from 'tailwind-merge';
export var DropdownMenuItem = function (_a) {
    var as = _a.as, children = _a.children, className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, rest = __rest(_a, ["as", "children", "className", "disabled"]);
    var Component = as || 'button';
    return (React.createElement(Component, __assign({}, rest, { "aria-disabled": disabled, role: rest.role || 'menuitem', tabIndex: disabled ? -1 : 0, className: twMerge('min-h-[2.75rem] my-[6px] w-full flex items-center px-4 text-left hover:bg-hover-grey active:bg-cerulean-20 cursor-pointer', disabled && 'text-alto pointer-events-none bg-none', className) }), children));
};
